function NotFound () {
    return (
        <h2 className="main__heading">
            Ошибка 404: Страница не найдена
        </h2>
    )
}

export default NotFound;